import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { authColors } from "../../../styles/authTokens";
import { duration, easing } from "../../../design-system/tokens/transitions";

/**
 * Auth-flow styling: colours come from `styles/authTokens.ts` (`authColors`),
 * matching `TenantSelectRow`/`TenantSelectList` — see those files for why
 * this auth-only pair exists separately from the app-wide `rawColors`.
 */

export const Wrap = styled.div`
  position: relative;
  width: 100%;
`;

/** Same visual language as `TenantSelectRow`'s `Row` — this is its closed state. */
export const Trigger = styled.button<{ $open: boolean }>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid
    ${({ $open }) => ($open ? authColors.buttonPrimary : authColors.inputBorder)};
  background: ${authColors.white};
  box-shadow: ${authColors.inputShadow};
  cursor: pointer;
  text-align: left;
  transition: border-color ${duration.fast} ${easing.smooth};

  &:hover:not(:disabled) {
    border-color: ${authColors.buttonPrimary};
  }

  &:focus-visible {
    outline: 2px solid ${authColors.buttonPrimary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export const TriggerBody = styled.span`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
`;

export const TriggerLabel = styled.span<{ $isPlaceholder: boolean }>`
  ${typographyMixin("body", 3)}
  color: ${({ $isPlaceholder }) =>
    $isPlaceholder ? authColors.textMedEmphasis : authColors.textHighEmphasis};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Chevron = styled.span<{ $open: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  transform: rotate(${({ $open }) => ($open ? "180deg" : "0deg")});
  transition: transform ${duration.fast} ${easing.smooth};
`;

export const MenuPanel = styled.div`
  box-sizing: border-box;
  position: fixed;
  ${popoverMotion()}
  z-index: 2000;
  min-height: 4rem;
  padding: 0.375rem;
  background: ${authColors.white};
  border: 1px solid ${authColors.inputBorder};
  border-radius: 0.5rem;
  box-shadow: ${authColors.panelShadow};
  overflow-y: auto;
  /* Set explicitly: leaving this to the default ("visible") would make the
     browser silently compute it as "auto" too (any axis pair where one side
     is non-"visible" forces the other to "auto"), which is how a single
     misbehaving child can put a horizontal scrollbar on this panel. */
  overflow-x: hidden;
`;
